import {
    createLocationPersonaFromPersonaType,
    LocationPersonaControlViewState,
} from 'owa-location-persona';
import LocationPersonaType from 'owa-calendar-scheduling-service/lib/schema/LocationPersonaType';

/**
 * Action to process the results of the FindPlaces service call.
 * It converts the response PersonaType to a LocationPersonaControlViewState
 */
export default function findPlacesResponseToLocationSuggestions(
    personaTypeSet: LocationPersonaType[],
    transactionId?: string,
    queryString?: string
): LocationPersonaControlViewState[] {
    let locationSuggestions: LocationPersonaControlViewState[] = [];
    if (personaTypeSet) {
        let index = 0;
        personaTypeSet.forEach(result => {
            let locationPersona = createLocationPersonaFromPersonaType(result);
            // Set up the relevance hint
            if (locationPersona) {
                locationPersona.relevanceData = {
                    relevanceHint: result.RelevanceHint,
                    locationIndex: index,
                    transactionId: transactionId ? transactionId : '',
                    locationFeedbackId: result.FeedbackId,
                    queryString: queryString ? queryString : '',
                };

                index++;
                locationSuggestions.push(locationPersona);
            }
        });
    }

    return locationSuggestions;
}
